import isEnumValue from '@orderna/admin-panel/src/utils/is-enum-value';

export enum TransactionStatus {
  REVERSED = 'reversed',
  APPROVED = 'approved',
  PENDING = 'pending',
  FAIL = 'fail',
  COMPLETED = 'completed',
  PARTIALLY_REVERSED = 'partially_reversed',
  VOID = 'void',
  PARKED = 'parked',
  CANCELLED = 'cancelled'
}

export const isTransactionStatus = (value: any) =>
  isEnumValue(TransactionStatus, value);
